module.exports = __webpack_public_path__ + "static/media/xmartlabs-logo.13b800e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/footer/xmartlabs-logo.svg
// module id = 343
// module chunks = 0 1 2